import {
  SET_EMAIL,
  RECOVERY_EMAIL_REQUEST,
  RECOVERY_EMAIL_SUCCESS,
  RECOVERY_EMAIL_FAILURE
} from 'constants/actionTypes';

const initialState = {
  email: '',
  errorText: '',
  isFetching: false
};


/**
 * Password Recovery Reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function passwordRecoveryReducer(state = initialState, action) {
  switch (action.type) {

    case SET_EMAIL:
      return {
        ...state,
        email: action.value.trim(),
        errorText: ''
      };

    case RECOVERY_EMAIL_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case RECOVERY_EMAIL_SUCCESS:
      return {
        ...state,
        email: action.email,
        errorText: '',
        isFetching: false
      };

    case RECOVERY_EMAIL_FAILURE:
      return {
        ...state,
        errorText: action.errorText,
        isFetching: false
      };

    default:
      return state;
  }
}
